<template>
    <div>
        <br>
        <el-form :inline="true" ref="form" :model="car" label-width="115px" size="mini">
            <el-form-item prop="ChePaiHao" :rules="[{ required: true,message:'请输入车牌号', trigger: 'blur' }]" label="车牌号">
                <el-input v-model="car.ChePaiHao"></el-input>
            </el-form-item>
            <el-form-item prop="PaiZhaoLeiXing" :rules="[{ required: true,message:'请选择牌照类型', trigger: 'blur' }]" class="sp-item" label="牌照类型">
                <el-select v-model="car.PaiZhaoLeiXing" filterable placeholder="选择类型">
                    <el-option v-for="item in licenseTypes" :key="item.ID" :label="item.Name" :value="item.ID">
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item prop="DaoLuYunShuNo" :rules="[{ required: true,message:'请输入运输证号', trigger: 'blur' }]" label="运输证号">
                <el-input v-model="car.DaoLuYunShuNo"></el-input>
            </el-form-item> -->
            <el-form-item prop="ZaiZhong" :rules="[{ required: true,message:'请输入载重', trigger: 'blur' }]" label="载重(吨)">
                <el-input type="number" min="0" step="0.001" v-model="car.ZaiZhong"></el-input>
            </el-form-item>
            <el-form-item prop="CarModelID" :rules="[{ required: true,message:'请选择车辆类型', trigger: 'blur' }]" class="sp-item" label="车辆类型">
                <el-select v-model="car.CarModelID" filterable placeholder="选择类型">
                    <el-option v-for="item in carModels" :key="item.ID" :label="item.Name" :value="item.ID">
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item prop="CarStructID" :rules="[{ required: true,message:'请选择车厢结构', trigger: 'blur' }]" class="sp-item" label="车厢结构" label-width="95px">
                <el-select v-model="car.CarStructID" filterable placeholder="选择结构">
                    <el-option v-for="item in carStructures" :key="item.ID" :label="item.Name" :value="item.ID">
                    </el-option>
                </el-select>
            </el-form-item> -->
            <!-- <el-form-item prop="GuiGeLength" :rules="[{ required: true,message:'请输入规格', trigger: 'blur' }]" label="挂车规格(mm)" class="item_inline">
                <div class="">
                    <el-input type="number" class="inline_input" placeholder="长" v-model="car.GuiGeLength"></el-input> ×
                    <el-input type="number" class="inline_input" placeholder="宽" v-model="car.GuiGeWidth"></el-input> ×
                    <el-input type="number" class="inline_input" placeholder="高" v-model="car.GuiGeHeight"></el-input>
                </div>
            </el-form-item> -->
            <!--  <el-form-item prop="XingShiZhengYouXiaoQiStart" :rules="[{ required: true,message:'请选择行驶证有效期', trigger: 'blur' }]" label="行驶证有效期">
                <el-date-picker type="date" placeholder="选择日期" v-model="car.XingShiZhengYouXiaoQiStart" style="width: 86%;"></el-date-picker>
            </el-form-item>
            <el-form-item prop="XingShiZhengYouXiaoQiEnd" :rules="[{ required: true,message:'请选择行驶证结束日期', trigger: 'blur' }]" label="至" label-width="85px">
                <el-date-picker type="date" placeholder="选择日期" v-model="car.XingShiZhengYouXiaoQiEnd" style="width: 84%;"></el-date-picker>
            </el-form-item>
            <el-form-item prop="ShangPaiRiQi" :rules="[{ required: true,message:'请选择上牌日期', trigger: 'blur' }]" label="上牌日期">
                <el-date-picker type="date" placeholder="选择日期" v-model="car.ShangPaiRiQi" style="width: 86%;"></el-date-picker>
            </el-form-item>
            <el-form-item prop="NianJian" :rules="[{ required: true,message:'请选择年检到期时间', trigger: 'blur' }]" label="年检到期" label-width="85px">
                <el-date-picker type="date" placeholder="选择日期" v-model="car.NianJian" style="width: 84%;"></el-date-picker>
            </el-form-item>
            <el-form-item prop="QiangXianBaoDanNo" :rules="[{ required: true,message:'请填写交强险保单号', trigger: 'blur' }]" label="交强险保单号">
                <el-input v-model="car.QiangXianBaoDanNo"></el-input>
            </el-form-item>
            <el-form-item prop="QiangXianDaoQiRi" :rules="[{ required: true,message:'请选择交强险到期日', trigger: 'blur' }]" label="交强险到期日">
                <el-date-picker type="date" placeholder="选择日期" v-model="car.QiangXianDaoQiRi" style="width: 84%;"></el-date-picker>
            </el-form-item>
            <el-form-item label="商业险保单号">
                <el-input v-model="car.ShangYeXianBaoDanNo"></el-input>
            </el-form-item>
            <el-form-item label="商业险到期日">
                <el-date-picker type="date" placeholder="选择日期" v-model="car.ShangYeXianDaoQiRi" style="width: 84%;"></el-date-picker>
            </el-form-item>
            -->
            <el-form-item class="item_inline is-required" label="行驶证照片">
                <el-upload :data="{type:'行驶证'}" :on-change="uploadChange" :file-list="car.XingShiZhengImages" :http-request="uploadFile" accept="image/*" :on-remove="uploadRemove" :limit="6" multiple :action="uploadUrl" list-type="picture-card">
                    <i class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>
            <el-form-item class="item_inline is-required" label="车辆照片">
                <el-upload :data="{type:'车辆照片'}" :on-change="uploadChange" :file-list="car.CheLiangImages" :http-request="uploadFile" accept="image/*" :on-remove="uploadRemove" :limit="6" multiple :action="uploadUrl" list-type="picture-card">
                    <i class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>
            <el-form-item class="item_inline is-required" label="交强险保单">
                <el-upload :data="{type:'交强险保单'}" :on-change="uploadChange" :file-list="car.JiaoQiangXianImages" :http-request="uploadFile" accept="image/*" :on-remove="uploadRemove" :limit="6" multiple :action="uploadUrl" list-type="picture-card">
                    <i class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>
            <el-form-item class="item_inline is-required" label="商业险保单">
                <el-upload :data="{type:'商业险保单'}" :on-change="uploadChange" :file-list="car.ShangYeXianImages" :http-request="uploadFile" accept="image/*" :on-remove="uploadRemove" :limit="6" multiple :action="uploadUrl" list-type="picture-card">
                    <i class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>
            <el-form-item class="item_inline is-required" label="道路运输证">
                <el-upload :data="{type:'道路运输证'}" :on-change="uploadChange" :file-list="car.DaoLuImages" :http-request="uploadFile" accept="image/*" :on-remove="uploadRemove" :limit="6" multiple :action="uploadUrl" list-type="picture-card">
                    <i class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>
        </el-form>
        <div class="center">
            <el-button @click="closedialog">取 消</el-button>
            <el-button @click="savecar" type="primary">确 定</el-button>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                uploadUrl: process.env.BASE_API+'/Apps/JYJYManage/ClientApi/UploadFile',
            }
        },
        props: ["car", "carModels", "carStructures", "licenseTypes"],
        methods: {
            uploadChange(file, fileList) {
                this.$emit('uploadchange', file, fileList)
            },
            uploadFile(f) {
                this.$emit('uploadfile', f)
            },
            uploadRemove(file, fileList) {
                this.$emit('uploadremove', file, fileList)
            },
            closedialog() {
                this.$emit('closedialog')
            },
            savecar() {
                let _this = this
                _this.$refs['form'].validate((valid) => {
                    if (valid) {
                        if (!_this.car.XingShiZhengImages||_this.car.XingShiZhengImages.length == 0) {
                            _this.$message({
                                message: "请上传行驶证照片",
                                type: "error"
                            });
                            return
                        }
                        if (!_this.car.CheLiangImages||_this.car.CheLiangImages.length == 0) {
                            _this.$message({
                                message: "请上传车辆照片",
                                type: "error"
                            });
                            return
                        }
                        if (!_this.car.JiaoQiangXianImages||_this.car.JiaoQiangXianImages.length == 0) {
                            _this.$message({
                                message: "请上传交强险照片",
                                type: "error"
                            });
                            return
                        }
                        if (!_this.car.ShangYeXianImages||_this.car.ShangYeXianImages.length == 0) {
                            _this.$message({
                                message: "请上传商业险照片",
                                type: "error"
                            });
                            return
                        }
                        if (!_this.car.DaoLuImages||_this.car.DaoLuImages.length == 0) {
                            _this.$message({
                                message: "请上传道路运输证照片",
                                type: "error"
                            });
                            return
                        }
                        _this.$emit('savecar', this.car)
                    } else {
                        return false;
                    }
                });
            }
        }
    }
</script>
<style>
    .el-col-1 {
        text-align: center
    }
    .item_inline {
        width: 100%;
    }
    .item_inline .el-form-item__content {
        width: 74%;
    }
    .item_inline .inline_input {
        width: 30.5%;
    }
    /* .item_inline .el-upload-list__item {
        width: 100px !important;
        height: 100px !important;
    } */
    .sp-item .el-select {
        width: 92%;
    }
</style>





// WEBPACK FOOTER //
// src/components/carDetail.vue